
export const REQUEST_EDITCLIP= 'REQUEST_EDITCLIP';
export const CLEAR_EDITCLIP= 'CLEAR_EDITCLIP';
export const EDITCLIP_RECEIVED = 'EDITCLIP_RECEIVED';